var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "user-info" }, [
    _c("img", {
      staticClass: "avatar",
      attrs: { src: require("@/assets/def_avatar_84px.png"), alt: "" },
    }),
    _c("div", { staticClass: "con" }, [
      _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.user.name))]),
      _c("div", { class: ["tag " + _vm.statusClass] }, [
        _vm._v(_vm._s(_vm.user.statusText)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }